import { createStore, compose, applyMiddleware } from 'redux';
import up from 'updeep';
import thunk from 'redux-thunk';
import { values } from 'lodash';
import queryString from 'query-string';
import localStorageMiddleware from './middleware/localStorage';
import { getLocaleFromWindowLocation } from '../lib/routerHelper';
import { leadersOrder } from '../lib/userApi';

export const DEFAULT_LOCATION = { input_location_mode: 5, input_income: 1, input_size: 0 };

const initialState = {
  auth: {
    data: {},
    canReset: true,
    password: '',
    passwordConfirm: '',
  },
  average_footprint: {
    inputs: DEFAULT_LOCATION,
  },
  user_footprint: {
    inputs: {},
    electricVehicles: {},
  },
  pledges: {},
  modalLeaderPledges: {},
  ui: {
    modal: '',
    modalLeader: null,
    spinner: false,
    unitSystem: getLocaleFromWindowLocation().toLowerCase() === 'en_ca' ? 'metric' : 'standard',
    external_offset: {},
    alerts: {
      sign_up: [],
      login: [],
      forgot_password: [],
      leaders: [],
      shared: [],
      activation: [],
    },
    take_action: {
      category_filter: 'all',
      status_filter: 'all',
      sort_by: 'inactive',
    },
    show_leaders_chart: false,
    alert_exists: false,
    connect_to_api: true,
    location_mode_changed: false,
    isGlobalMenuVisible: true,
    monthlyInputs: {},
    widget: null,
    leadersFilterForm: values(leadersOrder).reduce((previous, order) => ({
      ...previous,
      [order]: {
        order,
        inputLocationCountry: {
          abbr: 'US',
          name: 'United States',
        },
      },
    }), {}),
  },
  leaders: {
    filter: {},
    filterForm: {},
    queriesByOrder: {},
  },
  toast: {
    on: true,
    message: 'For example',
  },
  errors: {},
  user: {
    public: true,
  },
  accountForm: {
    descriptionMD: '',
    public: true,
  },
  locationAutocomplete: {},
  search: queryString.parse(window.location.search || ''),
};

export default (i18n, initialStateOverride = {}) => {
  const reducer = (state, { payload = {} }) => up(payload, state);
  // eslint-disable-next-line no-underscore-dangle
  const enhancer = window.__REDUX_DEVTOOLS_EXTENSION__ ?
    compose(
      applyMiddleware(thunk.withExtraArgument(i18n), localStorageMiddleware.save),
      // eslint-disable-next-line no-underscore-dangle
      window.__REDUX_DEVTOOLS_EXTENSION__(),
    ) :
    compose(
      applyMiddleware(
        thunk.withExtraArgument(i18n),
        localStorageMiddleware.save,
      ),
    );

  return createStore(
    reducer,
    localStorageMiddleware.load(up(initialStateOverride, initialState)),
    enhancer,
  );
};
